import { render, staticRenderFns } from "./report-dialog.vue?vue&type=template&id=3168137f&scoped=true&"
import script from "./report-dialog.vue?vue&type=script&lang=js&"
export * from "./report-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168137f",
  null
  
)

export default component.exports